export const draftDialogEditedSelector = (state) =>
  state.draftDialogReducer.draftDialogEdited;
